module.exports = {
        pleaseWait:'ခဏစောင့်ပါ',
        loading:'လုပ်ဆောင်နေသည်',
        Billing:'မှတ်တမ်း',
        billingTips:'ဝယ်ယူခြင်း နှင့် အသုံးပြုမှုမှတ်တမ်း',
        ID:'ကုတ်နံပါတ်',
        FAQ:'သိလိုရာများ',
        TC:'စည်းမျဥ်းများ',
        Copyright:'© 2025 All Rights Reserved.',
        GenerateImage:'ပုံဖန်တီးခြင်း',
        generateTips1:'ကျွန်ုပ်တို့၏ AI ရုပ်ပုံထုတ်ပေးသည့်စက်သည် စိတ်ကူးစိတ်သန်းများကို အသက်ဝင်စေကာ ရင်သပ်ရှုမောဖွယ်အနုပညာ၊ သရုပ်ဖော်ပုံများနှင့် ဓာတ်ပုံများကို စက္ကန့်ပိုင်းအတွင်း ထုတ်လုပ်ပေးပါသည်။ တီထွင်ဖန်တီးနိုင်စွမ်းကို ထုတ်ဖော်ပြီး AI ၏ နည်းလမ်းသစ်များဖြင့် သင့်ရုပ်ပုံအသစ်အဆန်းများကို ဖန်တီးပါ။ တစ်မူထူးခြားသော စျေးကွက်ရှာဖွေရေးပစ္စည်းများကို ဖန်တီးခြင်းမှ လှပသောအနုပညာလက်ရာများဖန်တီးခြင်းအထိ အဆုံးမရှိဖြစ်နိုင်ချေများကို စူးစမ်းလေ့လာပါ။·',
        generateTips2:'အောက်က စကားလုံးတချို့ ကို ရိုက်ထည့်ပြီး beautiGen က စာသားကို မယုံနိုင်လောက်အောင် အနုပညာအဖြစ် ပြောင်းလဲတာကို ကြည့်လိုက်ပါ',
        Prompt:'လျင်မြန်သော',
        PromptTips1:'ဘာဆွဲရမလဲဆိုတာ AI ကိုပြောပါ။',
        PromptTips2:'ခံစားချက်နှင့် အလင်းရောင်ကို ဖော်ပြပါ။',
        PromptTips3:'မှတ်ချက်။ AI မှ သင့်လမ်းညွှန်ချက်အတိုင်း ပုံမဖော်နိုင်ခဲ့ပါက ထိုအသုံးပြုမှုကို ထည့်သွင်းရေတွက်မည် မဟုတ်ပါ။',
        Generate:'ပုံထုတ်ပါ',
        ChancesLeft:'လက်ကျန်အကြိမ်ရေ',
        BuyChances:' အကြိမ်ရေထပ်မံဝယ်ယူရန် ',
        generateImageTips1:'ပုံ၏ဖော်ပြချက်ရိုက်ထည့်ပါ',
        generatePromptsTips1:'ကော်မာများဖြင်ခွဲခြားထားသော အနှတ်လက္ခဏာများထည့်သွင်းပါ',
        indexTips1:'နေ့စဥ်အခမဲ့အကြိမ်ရေ <br /> ရရှိပါသည်။',
        indexTips2:'တစ်ခုကိုရွေးပါ',
        ImageRestorer:'ရုပ်ပုံသိမ်းဆည်းခြင်း',
        Continue:'ဆက်သွားပါ',
        language0:'ဘာသာစကား',
        language:'ဘာသာစကားရွေးချယ်ပါ',
        languageTips:'ဒီနေရာတွင်ဘာသာစကားရွေးချယ်ပါ',
        Submit:'တင်သွင်းပါ',
        change:'ပြောင်းလဲရန် ',
        English:'အင်္ဂလိပ်',
        Myanmar:'မြန်မာဘာသာ',
        Login:'ဝင်ရန်',
        Logout:'အကောင့်မှထွက်ရန်',
        getCode:'ပြန်ပို့မည်',
        loginTips:'ဖုန်းနံပါတ်ဖြည့်ပါ',
        profile:'မိမိအကောင့်',
        phoneNumber:'ဖုန်းနံပါတ်',
        SubscribedSince:'စာရင်းသွင်းသည့်နေ့ ',
        RemainingChances:'ကျန်ရှိနေသောအခွင့်အလမ်းများ',
        cgtips2:'နေ့စဥ် ၁၄၉ကျပ်​/စာရင်းသွင်းရန် OK ကိုနှိပ်ပါ။',
        cgtips2W:'အပတ်စဥ် ၅၉၉ကျပ်​/စာရင်းသွင်းရန် OK ကိုနှိပ်ပါ။',
        cgtips2M:'လစဥ် ၁၉၉၉ကျပ်​/စာရင်းသွင်းရန် OK ကိုနှိပ်ပါ။',
        OK:'OK',
        Upload:'တင်သည်။',
        PictureRestorer:'ပုံသိမ်းဆည်းခြင်း',
        PictureTips1:'AI ဖြင့် ပုံများကိုအရောင်အသွေးလှပစွာဖြင့်နဂိုအတိုင်းပြန်လည်ပြုပြင်ပါ။ beautiGen သည် ခြစ်ရာများကို ဖယ်ရှားရန်၊ အရောင်များကို ပေါ်လွင်လာစေရန်နှင့် မျက်နှာများကို ​​​ကြည်လင်လာစေရန်၊ ပျက်စီးနေသော ဓာတ်ပုံများကို မြတ်နိုးဖွယ် အမှတ်တရများအဖြစ်သို ပြောင်းလဲရန်အတွက် နောက်ဆုံးပေါ် သုတေသနကို တည်ဆောက်ပါသည်။ ကျွန်ုပ်တို၏ ဝန်ဆောင်မှုသည် အရောင်ဓာတ်ပုံများနှင့် အဖြူအမည်းများကို အခမဲ့ပြုပြင်ပေးပါသည်',
        PictureTips2:'ခြစ်ရာတွေရှိပါသလား',
        Restore:'သိမ်းဆည်းထားမည်',
        uploadTips:'ကျေးဇူးပြု၍ပုံတင်သွင်းပါ',
        PurchaseChances:'Chance ဝယ်ယူမည်',
        History:'ပုံမှတ်တမ်း',
        purchaseTips1:'စုစုပေါင်းအခွင့်အရေး',
        purchaseTips2:'အကြိမ်ရေထပ်မံဝယ်ယူမည်',
        Daily:'နေ့စဥ်',
        Weekly:'အပတ်စဥ်',
        OneTime:'တစ်ကြိမ်',
        Purchase:'ဝယ်ယူမည်',
        DailyKyats:'149 Kyats',
        WeeklyKyats:'599 Kyats',
        OneTimeChance:'129 Ks/Chance',
        Subscribe:'စာရင်းသွင်းပါ',
        purchaseTips3:'တစ်ကြိမ် ထပ်မံ ဝယ်ယူရန် ဝယ်ယူမည် ကို နှိပ်ပါ',
        BuyNow:'ဝယ်ယူမည်',
        comingsoonT:'မကြာမီ',
        logOut:'လော့ဂ်အောက်ထွက်သည်',
        petTitle1:'တိရစ္ဆာန် ကာတွန်းပုံ',
        petTitle2:'စတိုင် ရွေးချယ်ပါ။',
        petContent1:' သင့်အိမ်မွေးတိရစ္ဆာန်လေးတွေရဲ့ဓာတ်ပုံကိုဆန်းသစ်တဲ့ကာတွန်းလက်ရာပုံလေးတွေအဖြစ်ပြောင်းလိုက်ပါ။အိမ်မွေးတိရစ္ဆာန်ချစ်သူလေးတွေနဲ့ကာတွန်းဝါသနာရှင်တွေရဲ့အမွှေးထူသူငယ်ချင်းလေးတွေအတွက် ပျော်ရွှင်စရာတွေနဲ့ ဂုဏ်ပြုပေးဖို့အကောင်းဆုံးပါပဲ။',
        sexTitle1:'လူကာတွန်းပုံ',
        sexTitle2:'ကျား/မ ရွေးချယ်ပါ။',
        sexContent1:'ဓာတ်ပုံလေးတွေကို စိတ်ကူးထဲက ကာတွန်းပုံလေးတွေအဖြစ် ပုံဖော်လို့ရပါပြီ။ သင်က ကာတွန်းတွေပုံပြင်တွေကြိုက်ပြီး ဒီဇိုင်းတွေတီထွင်ရတာကြိုက်တဲ့သူဆိုရင် အဆင့်မြင့် AI ရဲ့ တီထွင် ဖန်တီးမှုကို စမ်းကြည့်လိုက်ပါ။',
        sexContent2:'ကြိုက်နှစ်သက်တဲ့ စတိုင်တစ်ခုကိုရွေးချယ်ပြီး ပြောင်းလဲချင်တဲ့ မိမိပုံတစ်ပုံကို တင်လိုက်ပါ။ အံ့သြစရာ ပုံလေးတွေ ထွက်လာပါလိမ့်မယ်။',
        Female:'မ',
        Male:'ကျား',
        Style1:'စတိုင် 1',
        Style2:'စတိုင် 2',
        Style3:'စတိုင် 3',
        Comic:'ရုပ်ပြ',
        Disney:'ဒစ်စနေး',
        Ghibli:'ဂစ်ဘလီ',
        Animalanime:'Selfie Anime',
        HumanAnime:'လူ',
        Guidance:'လမ်းညွှန်ချက်',
        PetAnime:'Pet Anime',
        landTips1:'ရင်သပ်ရှုမောဖွယ် ဓာတ်ပုံများကို ဖန်တီးပြီး',
        landTips2:'ဆုကြီးများကို ရယူလိုက်ပါ',
        landTips3:'သင့်ရဲ့စိတ်ကူးတွေကို beautiGen နဲ့ လက်တွေ့ပြောင်းလဲလိုက်ပါ။ အံ့မခန်းပုံတွေဖန်တီးမှုများမှစ၍ အနုပညာလက်ရာများအထိ အရင်ကမတွေ့ဖူးသေးတာတွေကိုbeautiGen ကသင့်ကို ဖန်တီးပေးပါလိမ့်မယ်။ အခုပဲအကန့်အသတ်မရှိတဲ့ ဖန်တီးမှုတွေကို စတင်လိုက်ပါ။',
        show401tip:'လက်ကျန် မလုံလောက်ပါ။',
        show400dailytip:'အချိန်ကုန်သွားပြီ၊ ကျေးဇူးပြု၍ 548 သို "ON1" ပေးပို၍ ဆုကြီးကြီးရယူပါ။',
        show400weeklytip:'အချိန်ကုန်သွားပြီ၊ ကျေးဇူးပြု၍ 548 သို "ON7" ပေးပို၍ ဆုကြီးကြီးရယူပါ။',
        register:'စာရင်းသွင်းပါ။',
        invitation:'ဖိတ်ခေါ်ခြင်း',
        invitationTips:'အောက်ပါဖိတ်ခေါ်ချက်လင့်ခ်ကို ကူးယူပြီး သူငယ်ချင်းထံပေးပို့ပါ',
        InviteNow:'အခုပဲ ဖိတ်ခေါ်မယ်',
        copySuccess:'ကူးယူမှု အောင်မြင်ပါသည်',
        process:'ပုံထုတ်နေသည်',
        downTips1:'ကျေးဇူးပြု၍ လင့်ခ်ကို browser ထဲသို့ ကူးယူပြီး ဒေါင်းလုဒ်လုပ်ပါ။',
        copyLink:'လင့်ခ်ကိုကူးယူပါ။',
        ChangeHairstyle:'ဆံပင်ပုံစံပြောင်းမယ်',
        ChangeHairstyle_content_1:'ကျွန်ုပ်တို့၏ စစ်စတမ်တွင် ဆံပင်ပုံစံများစွာကိုလည်း ပြောင်းလဲလို့ရနိုင်ပါသည်။ အသုံးပြုသူ၏ မျက်နှာသွင်ပြင် အနေအထား နှင့် ကြိုက်နှစ်သက်ရာ ဆံပင်ပုံစံကိုရွေးချယ်ပြီး AI နည်းပညာက စမ်းသစ်စွာ ဖန်တီးပေးခြင်းကို စမ်းကြည့်နိုင်ပါသည်။ မတူညီသောဆံပင်ပုံစံများကို လွယ်ကူစွာ ပြောင်းလဲ ရှာဖွေစမ်းသပ်ခြင်းဖြင့် စိတ်ပျော်ရွှင်မှုများကို ရယူနိုင်ပါသည်။',
        ChangeHairstyle_content_2:'အောက်တွင်ပါရှိသော ဆံပင်ပုံများမှကြိုက်နှစ်သက်ရာ ဆံပင်စတိုင်ကိုရွေးချယ်ပြီး မိမိပုံကိုထည့်သွင်းပါ။ လှပေသာ ဆံပင်စတိုင်နှင့်ပုံလေးကို ရရှိမှာပါ။',
        SmartCutout:'နောက်ခံပုံဖျက်',
        SmartCutout_content :'ကျွန်ုပ်တို့ရဲ့ နောက်ခံပုံဖျက်သည့် လုပ်ဆောင်မှုသည် သင့်ရဲ့ပုံများကို AI ရဲ့ တိကျမှုဖြင့် စွမ်းဆောင်ပေးမှာပါ။ သင်က ပုံများကို ပရော်ဖက်ရှင်နယ်အနေနဲ့ ဖန်တီးရတာကြိုက်တဲ့သူ၊ အပျော်သဘောဖြင့် ဆိုရှယ်မီဒီယာပိုစ့် နဲ့ အနုပညာဆိုင်ရာတည်းဖြတ်မှုများလုပ်ရတာ ကြိုက်တဲ့သူဆိုရင် ဒီလုပ်ဆောင်ချက်က သင့်ပုံများကို တစ်ချက်တည်းနှင့် တိကျသေချာစေတဲ့ ပုံဖြတ်တောက်မှုကို ရရှိစေမှာပါ။',
        IpIMage:'လိုင်စင်ပုံ',
        IpIMage_content:'လိုင်စင်ဓာတ်ပုံအဖြစ် ပြောင်းလဲလိုသော မူရင်းပုံသည် ကြည်လင်ပြတ်သားပြီး မျက်နှာသည် ရှေ့တည့်တည့်အနေအထားဖြစ်ရမည်။ ပခုံးများသည် \n' +
          'လိုင်စင်ပုံများအတိုင်းတပြေးညီအနေအထားဖြစ်ရမည်။ မဟုတ်ပါက ပြောင်းလဲ၍မရနိုင်ပါ။',
        landfont3:'သင့်စိတ်ကူးထဲက ပုံများကို ဖန်တီးလိုက်ပါ',
        landfont1:'သင့်ဓာတ်ပုံကို ကာတွန်းပုံအဖြစ် ဖန်တီးမယ်',
        landfont2:'သင့်ဓာတ်ပုံရဲ့ နောက်ဘက် background များကို ဖျက်မယ်',
        landfont4:'သင့်စိတ်ကူးထဲက ဆံပင်ပုံစံများကို ပြောင်းကြမယ်',
        landfont5:'သင့်ဓာတ်ပုံကို လိုင်စင်ပုံအဖြစ် ဖန်တီးမယ်',
        select:'ပက်ကေ့ချ် ရွေးချယ်ပါ',
        Monthly:'လစဉ်',
        landFree:'မေလ ၁၀ ရက်နေ့မှ ဇွန်လ ၁၀ ရက်နေ့အထိ အခမဲ့',
        free:'အခမဲ့',
        snapbot:'BtgenBot',
        snapbot_hi:'မင်္ဂလာပါ၊ ကျွန်တော် BtgenBot ဖြစ်ပါတယ်။',
        snapbotTips1:'မြန်ဆန်သော ရှာဖွေမှုရလဒ်',
        snapbotTips2:'နားလည်နိုင်စွမ်းနှင့် ဖြေရှင်းနိုင်စွမ်း',
        snapbotTips3:'ဒေတာအများအပြား စီစစ်နိုင်ခြင်း',
        snapbotTips4:'ဉာဏ်ရည်တု အယ်လဂိုရီသမ်',
        snapbotInput1:'BtgenBot နဲ့ စတင် စကားပြောမယ်',
        help_today:'ဒီနေ့မှာ ဘာတွေကူညီပေးရမလဲ?',
        think_ip:'🤖 စဉ်းစားနေပါပြီ...',
        white:'အဖြူ',
        blue:'အပြာ',
        '1 inch':'1 လက်မ',
        '2 inches':'2 လက်မ',
        '3 inches':'3 လက်မ',
      re_sub_tip:'သင်ဝန်ဆောင်မှုကို ပယ်ဖျက်ပြီးပြီလား ?',
      subscribe:'စာရင်းသွင်းပါ။',
      login_tip_2:'၇ရက်စာ အခမဲ့အပြင် သတ်တမ်းတိုး၀ယ်ယူမှုတိုင်းအတွက် အက်တမ်စတားပွိုင့် ၃၀ကိုရယူလိုက်ပါ',
      redirect_tip:'သင့်အား ဘရောက်ဆာသို့ ပြန်လည်ညွှန်းပေးပါမည်။',
      UNSUBSCRIBE:'ပယ်ဖျက်မည်',
}



// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js